const MINIMUM_ARTWORKS_TO_PUBLISH = 6;

export const useSelectionActions = () => {
  const appState = useAppState();
  const { isLoggedIn } = useAuth();
  const route = useRoute();

  const toggleSavingArtwork = async (
    id: string | null | undefined,
    confirmRemoval?: () => boolean | Promise<boolean>,
  ) => {
    if (!id) return;

    if (!isLoggedIn.value) {
      navigateTo({ path: '/signin', query: { redirect: route.fullPath } });
      return;
    }

    // Open the new save to selection modal
    appState.activeArtworkIdForModal.value = id;
    appState.isSaveModalOpen.value = true;
  };

  return {
    toggleSavingArtwork,
  };
};
